export function formatCurrency(amount: number): string {
  return `$${amount.toFixed(0)}`;
}

export function roundToNearest(value: number, step: number = 1): number {
  return Math.round(value / step) * step;
}

export function parseFloatSafe(value: string | number): number {
  const parsed = parseFloat(String(value));
  return isNaN(parsed) ? 0 : parsed;
}

export function formatUSD(amount: number): string {
  return `$${amount.toLocaleString()}`;
}
